<template>
  <div>
    <div class="row">
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <input type="button" value="金融機関・支店選択" @click="openingBaseModal = true, openingSelectBankModal = true" class = "btn btn-submit">
      </div>
    </div>

    <div class="row">
      <!-- 金融機関名 -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label" for="store_bank_account_attributes_bank_name">金融機関名</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['bank_name']}" type="text" v-model="bankName" name="store[bank_account_attributes][bank_name]" id="store_bank_account_attributes_bank_name">
        <div v-if="errorsHash['bank_name']" class="invalid-feedback">金融機関名 {{ errorsHash['bank_name'][0] }}</div>
      </div>

      <!-- 金融機関コード -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label" for="store_bank_account_attributes_bank_code">金融機関コード</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['bank_code']}" type="text" v-model="bankCode" name="store[bank_account_attributes][bank_code]" id="store_bank_account_attributes_bank_code">
        <div v-if="errorsHash['bank_code']" class="invalid-feedback">金融機関コード {{ errorsHash['bank_code'][0] }}</div>
      </div>
    </div>

    <div class="row">
      <!-- 支店名 -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label" for="store_bank_account_attributes_bank_branch_name">支店名</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['bank_branch_name']}" type="text" v-model="bankBranchName" name="store[bank_account_attributes][bank_branch_name]" id="store_bank_account_attributes_bank_branch_name">
        <div v-if="errorsHash['bank_branch_name']" class="invalid-feedback">支店名 {{ errorsHash['bank_branch_name'][0] }}</div>
      </div>

      <!-- 支店コード -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label" for="store_bank_account_attributes_bank_branch_code">支店コード</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['bank_branch_code']}" type="text" v-model="bankBranchCode" name="store[bank_account_attributes][bank_branch_code]" id="store_bank_account_attributes_bank_branch_code">
        <div v-if="errorsHash['bank_branch_code']" class="invalid-feedback">支店コード {{ errorsHash['bank_branch_code'][0] }}</div>
      </div>

      <!-- 科目 -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label" for="store_bank_account_attributes_account_type">科目</label>
        <div class="form-check">
          <input id="account-type-normal" class="form-check-input" type="radio" value="1" name="store[bank_account_attributes][account_type]" v-model="accountType">
          <label for="account-type-normal" class="form-check-label">
            普通
          </label>
        </div>
        <div class="form-check">
          <input id="account-type-current" class="form-check-input" type="radio" value="2" name="store[bank_account_attributes][account_type]" v-model="accountType">
          <label for="account-type-current" class="form-check-label">
            当座
          </label>
        </div>
      </div>

    </div>

    <div class="row">
      <!-- 口座番号 -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label" for="store_bank_account_attributes_account_number">口座番号</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['account_number']}" type="text" v-model="accountNumber" name="store[bank_account_attributes][account_number]" id="store_bank_account_attributes_account_number">
        <div v-if="errorsHash['account_number']" class="invalid-feedback">口座番号 {{ errorsHash['account_number'][0] }}</div>
      </div>

      <!-- 口座名義 -->
      <div class="form-group col-xl-3 col-lg-3 col-md-6 col-sm-6">
        <label class="control-label" for="store_bank_account_attributes_account_name">口座名義</label>
        <input class="form-control" :class="{'is-invalid': errorsHash['account_name']}" type="text" v-model="accountName" name="store[bank_account_attributes][account_name]" id="store_bank_account_attributes_account_name">
        <div v-if="errorsHash['account_name']" class="invalid-feedback">口座名義 {{ errorsHash['account_name'][0] }}</div>
      </div>
    </div>

    <base-modal
      v-if="openingBaseModal"
    >
      <select-bank-modal
        v-show="openingSelectBankModal"
        :api-key="apiKey"
        @closeModal="openingBaseModal = false, openingSelectBankModal = false"
        @openSelectBankBranch = "openSelectBankBranchModal"
      />
      <!-- 支店検索画面は再レンダリングしたいためv-if -->
      <select-bank-branch-modal
        v-if="openingSelectBankBranchModal"
        :api-key="apiKey"
        :bank-code="tempStorageBankCode"
        @backSelectBankModal="openingSelectBankModal = true, openingSelectBankBranchModal = false"
        @decision="setStorage"
      />
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '../modal/base_modal.vue'
import SelectBankModal from '../modal/select_bank_modal.vue'
import SelectBankBranchModal from '../modal/select_bank_branch_modal.vue'

export default {
  components: {
    BaseModal,
    SelectBankModal,
    SelectBankBranchModal
  },
  data () {
    return {
      openingBaseModal: false,
      openingSelectBankModal: false,
      openingSelectBankBranchModal: false,
      tempStorageBankName: null,
      tempStorageBankCode: null,
      dispBankName: model['bank_name'],
      dispBankCode: model['bank_code'],
      dispBankBranchName: model['bank_branch_name'],
      dispBankBranchCode: model['bank_branch_code'],
      dispAccountType: model['account_type'],
      dispAccountNumber: model['account_number'],
      dispAccountName: model['account_name'],
      // erb上で宣言した定数
      apiKey: model['apikey'],
      errorsHash: model['errors']
    }
  },
  computed: {
    bankName: {
      get () {
        return this.dispBankName
      },
      set (value) {
        this.dispBankName = value
      }
    },
    bankCode: {
      get () {
        return this.dispBankCode
      },
      set (value) {
        this.dispBankCode = value
      }
    },
    bankBranchName: {
      get () {
        return this.dispBankBranchName
      },
      set (value) {
        this.dispBankBranchName = value
      }
    },
    bankBranchCode: {
      get () {
        return this.dispBankBranchCode
      },
      set (value) {
        this.dispBankBranchCode = value
      }
    },
    accountType: {
      get () {
        if (this.dispAccountType) {
          return this.dispAccountType
        } else {
          return 1
        }
      },
      set (value) {
        this.dispAccountType = value
      }
    },
    accountNumber: {
      get () {
        return this.dispAccountNumber
      },
      set (value) {
        this.dispAccountNumber = value
      }
    },
    accountName: {
      get () {
        return this.dispAccountName
      },
      set (value) {
        this.dispAccountName = value
      }
    }
  },
  methods: {
    openSelectBankBranchModal (value) {
      this.tempStorageBankName = value.bankName
      this.tempStorageBankCode = value.bankCode
      this.openingSelectBankModal = false
      this.openingSelectBankBranchModal = true
    },
    setStorage (value) {
      this.bankName = this.tempStorageBankName
      this.bankCode = this.tempStorageBankCode
      this.bankBranchName = value.bankBranchName
      this.bankBranchCode = value.bankBranchCode
      this.openingSelectBankBranchModal = false
      this.openingBaseModal = false
    }
  }
}
</script>
